import { useMemo } from 'react'

export interface BenefitsJourneyProgress {
  totalProgress: number
  sections: {
    name: string
    progress: number
    description: string
  }[]
}

/**
 * Hook to calculate member's Benefits Journey progress
 * Returns progress metrics for each benefit category
 */
export function useBenefitsJourneyProgress() {
  // Mock data - in production, fetch from API using queries
  const progress = useMemo<BenefitsJourneyProgress>(() => {
    return {
      totalProgress: 68,
      sections: [
        {
          name: 'CPD Bank',
          progress: 85,
          description: '45/50 CPD credits completed',
        },
        {
          name: 'Training & Events',
          progress: 60,
          description: '6/10 events attended',
        },
        {
          name: 'Communities',
          progress: 50,
          description: 'Joined 3/5 recommended communities',
        },
        {
          name: 'Essential Documents',
          progress: 80,
          description: '8/10 documents reviewed',
        },
      ],
    }
  }, [])

  return progress
}
